import { ConfirmationBanner } from "../../../organisms/ConfirmationBanner/ConfirmationBanner";
import { NavigationButton } from "../../../atoms/NavigationButton";
import { useWasteStore } from "../../../../store/store";
import { FunctionComponent, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { RoutesList } from "@routes/Routes";
import InternalServerError from "@components/pages/not-found/InternalServerError";

export const Confirmation: FunctionComponent = () => {
  const {
    wasteCategory,
    receiveConfirmationEmail,
    confirmation,
    resetAllUploadPhoto,
    resetAllWasteDetails,
    resetYourDetails,
  } = useWasteStore();

  const location = useLocation();

  const handlePopstate = () => {
    if (location.pathname === RoutesList.CONFIRMATION) {
      window.location.href = "https://www.westminster.gov.uk/";
      localStorage.removeItem("waste-details-storage");
      resetAllUploadPhoto();
      resetAllWasteDetails();
      resetYourDetails();
    }
  };

  useEffect(() => {
    window.addEventListener("popstate", handlePopstate);
  }, []);

  if (!confirmation || !confirmation.case_reference) {
    return <InternalServerError />;
  }
  window.removeEventListener("popstate", handlePopstate);

  const crmId = sessionStorage.getItem("crmId");
  const isLoggedInUser =
    receiveConfirmationEmail.toLowerCase() === "yes" &&
    crmId !== null &&
    crmId !== undefined &&
    crmId.length > 0;

  const redirectionLink = isLoggedInUser
    ? "https://mywestminster.westminster.gov.uk/"
    : "https://www.westminster.gov.uk/report-it";

  const returnButtonText = isLoggedInUser
    ? "Return to MyWestminster"
    : "Return to Report it home";

  return (
    <>
      <ConfirmationBanner reference={confirmation?.case_reference} />
      <section className="my-10 flex flex-col gap-y-8 p-6">
        <div className=" text-[41px] font-semibold leading-tight">
          What happens next?
        </div>
        <p className="text-xl">
          You have reported{" "}
          <span className="font-semibold">
            {wasteCategory.replaceAll("_", " ").substring(0, 1).toUpperCase() +
              wasteCategory
                .replaceAll("_", " ")
                .substring(1, wasteCategory.length)}
          </span>
          .
        </p>

        <p>
          {`${
            confirmation?.sla_text
              ? `We will review your report within `
              : `We will review your report`
          }`}
          <span className="font-semibold">{confirmation?.sla_text}.</span>
        </p>
        {receiveConfirmationEmail.toLowerCase() === "yes" && (
          <p>
            You will receive an email confirmation. Please check your inbox.
          </p>
        )}

        {isLoggedInUser && (
          <p>
            You can view your report in your{" "}
            <a href="https://mywestminster.westminster.gov.uk/">
              MyWestminster account.
            </a>
          </p>
        )}
      </section>
      <NavigationButton
        navigateToDestination={() => {}}
        href={redirectionLink}
        isExternal={true}
        text={returnButtonText}
        className="mx-6 inline-flex rounded-md bg-button-default"
      />
    </>
  );
};
